<template>
  <BittsEmptyState
    :font-awesome-icon="params.icon"
    :font-awesome-icon-style="{ height: '26px', width: '26px' }"
    font-awesome-icon-class="bitts-table-pro-empty-state__icon"
    :title="params.title"
    :description="params.descriptionHtml ? undefined : params.description"
  >
    <template v-if="params.descriptionHtml" #description>
      <div class="text-neutral-text" v-html="params.descriptionHtml" />
    </template>
  </BittsEmptyState>
</template>

<script setup lang="ts">
import BittsEmptyState from '../BittsEmptyState/BittsEmptyState.vue';
import { BittsIcon } from '../types';

const { params } = defineProps<{
  params: {
    title: string;
    description?: string;
    descriptionHtml?: string;
    icon?: BittsIcon;
  };
}>();
</script>

<style lang="pcss">
@reference "../../../../apps/crossbeam-app/src/css/theme.css";
.bitts-table-pro-empty-state__icon {
  @apply text-neutral-text-weak p-20 rounded-[36px];
  background: radial-gradient(
      136.96% 69.92% at 50.09% -12.42%,
      theme(colors.neutral.accent / 0.2) 0%,
      theme(colors.neutral.accent / 0) 100%
    ),
    linear-gradient(0deg, theme(colors.white), theme(colors.white));
}
</style>
